import React, { useMemo } from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { PolygonLongLogo } from 'src/utils/icons/polygonLongLogo';
import Vendor from '../../vendor.config';

export const PoweredByLabel = () => {
	const content: { logo: React.ReactNode; color: string } = useMemo(
		() =>
			Vendor.gui.asset.logo.includes('game_explorer_logo')
				? {
						color: '#7950DD',
						logo: <PolygonLongLogo />,
				  }
				: {
						color: '#FF3F3F',
						logo: (
							<Image
								height="56px"
								src="\icons\hashup_powered_by_label.svg"
							/>
						),
				  },
		[]
	);

	return (
		<Flex
			position="fixed"
			zIndex="banner"
			top="33%"
			right="0"
			transform="translateY(-50%)"
		>
			{/** Filler */}
			<Flex
				position="fixed"
				top="50%"
				right="0"
				transform="translateY(-50%)"
				borderRadius="8px 0px 0px 8px"
				direction="column-reverse"
			>
				<Flex
					bgColor="#242424"
					borderRadius="0px 0px 0px 8px"
					border="1px solid #2F2F2F"
					padding="12px"
					fontSize="9px"
					transform="skewY(15deg)"
					marginTop="-2em"
				>
					<Text
						lineHeight="10px"
						letterSpacing="0.1em"
						textTransform="uppercase"
						fontWeight="600"
						color="white"
						css={{
							writingMode: `vertical-rl`,
						}}
						transform="rotate(180deg)"
						filter="opacity(0)"
					>
						Powered byMM
					</Text>
				</Flex>
				<Box>
					<Flex
						bgColor={content.color}
						filter={`blur(14px)`}
						position="absolute"
						borderRadius="8px 0px 0px 0px"
						border="1px solid #FFFFFF20"
						transform={`skewY(-15deg)`}
						padding="12px"
					>
						{content.logo}
					</Flex>
					<Flex
						bgColor={content.color}
						borderRadius="8px 0px 0px 0px"
						border="1px solid #FFFFFF20"
						transform={`skewY(-15deg)`}
						padding="12px"
					>
						<Box filter="opacity(0)">{content.logo}</Box>
					</Flex>
				</Box>
			</Flex>
			{/** Content */}
			<Flex
				direction="column"
				zIndex="banner"
			>
				<Box padding="12px">{content.logo}</Box>
				<Box padding="12px">
					<Text
						lineHeight="10px"
						letterSpacing="0.1em"
						textTransform="uppercase"
						fontWeight="600"
						fontSize="9px"
						color="white"
						css={{
							writingMode: `vertical-rl`,
						}}
						transform="rotate(180deg)"
					>
						Powered by
					</Text>
				</Box>
			</Flex>
		</Flex>
	);
};
